import script from "./BrochureUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./BrochureUpload.vue?vue&type=script&setup=true&lang=js"

import "./BrochureUpload.vue?vue&type=style&index=0&id=ea783dc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea783dc2"]])

export default __exports__